import HeroSection from '../components/HeroSection'
import { AssetsFlexibilitySection } from '../components/AssetsFlexibilitySection'
import SoleraTypesSection from '../components/SoleraTypesSection'
import AuditedBy from '../components/AuditedBy'

const Home = () => {
  return (
  <div className='bg-black'>
    <HeroSection/>
    <AssetsFlexibilitySection/>
    <SoleraTypesSection/>
    <AuditedBy/>
  </div>
  )
}

export default Home
